(function() {
  'use strict';
  if (!document.body.classList.contains('template-collection')) return;
  const cardSelector = '.template-collection .product-grid .card, .template-collection .products-grid .product-card';
  const markReady = (card) => card.classList.add('is-ready');

  function initCards() {
    const cards = document.querySelectorAll(cardSelector);
    if (!cards.length) return;

    cards.forEach((card) => {
      if (card.classList.contains('is-ready')) return;
      const img = card.querySelector('img');
      if (!img) {
        markReady(card);
        return;
      }

      if (img.complete && img.naturalWidth > 0) {
        markReady(card);
        return;
      }

      const onDone = () => {
        markReady(card);
        img.removeEventListener('load', onDone);
        img.removeEventListener('error', onDone);
      };

      img.addEventListener('load', onDone, { once: true });
      img.addEventListener('error', onDone, { once: true });
    });
  }

  if (window.Shopify && Shopify.designMode) {
    initCards();
    const observer = new MutationObserver(() => initCards());
    observer.observe(document.body, { childList: true, subtree: true });
    return;
  }

  initCards();
})();
